import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SummaryCreateDTO, SummaryDocumentDTO, SummaryDTO} from '../../dto/summary';
import {environment} from '../../../../../environments/environment';
import {map} from 'rxjs/operators';
import {getHeadersEventSource} from '../../../../utils/interceptors/http-header.interceptor';
import {SseClient} from 'ngx-sse-client';
import {DeviceIdService} from '../../../../utils/services/device-id.service';

@Injectable({
  providedIn: 'root'
})
export class SummaryService {
  private readonly sseClient: SseClient = inject(SseClient);
  private readonly deviceIdService: DeviceIdService = inject(DeviceIdService);
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiUrl = environment.apiBaseUrl + '/summary';

  getProjectSummaries(projectId: number): Observable<SummaryDTO[]> {
    const url = `${this.apiUrl}/${projectId}`;
    return this.http.get<SummaryDTO[]>(url);
  }

  getProjectSummaryById(summeryId: number, projectId: number): Observable<SummaryDTO> {
    const url = `${this.apiUrl}/${projectId}/summary/${summeryId}`;
    return this.http.get<SummaryDTO>(url);
  }

  getPaperSummary(projectId: number, paperId: number): Observable<SummaryDocumentDTO> {
    const url = `${this.apiUrl}/${projectId}/paper/${paperId}`;
    return this.http.get<SummaryDocumentDTO>(url);
  }

  isSummaryProcessRunning(projectId: number): Observable<boolean> {
    const url = `${this.apiUrl}/${projectId}/process/running`;
    return this.http.get(url, {observe: 'response'}).pipe(
      map(response => response.status === 200)
    );
  }

  stopSummaryProcess(projectId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${projectId}/process/stop`);
  }

  generateProjectSummary(projectId: number, summary: SummaryCreateDTO): Observable<SummaryDTO> {
    const headers = getHeadersEventSource(this.deviceIdService.getDeviceId());
    const url = `${this.apiUrl}/${projectId}`;
    return this.sseClient.stream(
      url,
      {keepAlive: false, responseType: 'event'},
      {body: summary, headers},
      'POST'
    ).pipe(
      map(event => {
        if (event.type === 'error') {
          const errorEvent = event as ErrorEvent;
          console.error(errorEvent.error, errorEvent.message);
          throw new Error('SSE connection error');
        }
        const messageEvent = event as MessageEvent;
        return JSON.parse(messageEvent.data) as SummaryDTO;
      })
    );
  }

  getPapersSummary(projectId: number, summaryId: number): Observable<SummaryDocumentDTO[]> {
    const url = `${this.apiUrl}/${projectId}/summary/${summaryId}/paper`;
    return this.http.get<SummaryDocumentDTO[]>(url);
  }

  deleteSummary(projectId: number, summaryId: number): Observable<void> {
    const url = `${this.apiUrl}/${projectId}/summary/${summaryId}`;
    return this.http.delete<void>(url);
  }

}
